'use client'
import { useLazyUserProfileDetailsQuery } from '@/src/api/rtkQuery/userApi'
import { refreshAuthUser, setClevertapProfile } from '@/src/redux/slices/authSlice'
import {
    invokeCustomEvent,
    loginPush,
    responseMapper,
    sendProfileData,
    toSerializableClevertapProfile,
    updateProfileData
} from '@/src/utils/analytics/clevertap'
import { isServer } from '@/src/utils/browser'
import { requestCleverTapWebPush } from '@/src/utils/analytics/clevertap/webPush'
import useSmilesEntry from '@/src/hooks/smiles/useSmilesEntry'
import { getMobileDeviceType } from '@/src/utils/deviceType'
import { isUserSignedIn } from '@/src/utils/generalUtils/checkUserLogin'
import { logError } from '@/src/utils/logError'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

export default function GlobalClientEffect() {
    const [triggerUserProfileDetails] = useLazyUserProfileDetailsQuery()
    const dispatch = useDispatch()

    useSmilesEntry()

    const getUserDetails = async (type: string) => {
        try {
            const response = await triggerUserProfileDetails()
            const { status, data } = response || {}
            if (status === 'fulfilled') {
                const finalPayload = responseMapper(data)
                if (finalPayload) {
                    const serializableProfile = toSerializableClevertapProfile(finalPayload)
                    if (serializableProfile) {
                        dispatch(setClevertapProfile(serializableProfile))
                    }
                    if (type == 'login') {
                        sendProfileData(finalPayload)
                    } else if (serializableProfile) {
                        updateProfileData(serializableProfile)
                    }
                }
            }
        } catch (e) {
            logError('getUserDetails', e)
        }
    }

    useEffect(() => {
        if (!isServer()) {
            dispatch(refreshAuthUser())
            setTimeout(() => {
                requestCleverTapWebPush()
            }, 1000)

            document.addEventListener('CLEVERTAP_PROFILE', function ({ detail }: any) {
                const deviceType = getMobileDeviceType()
                if (deviceType !== 'AndroidApp' && deviceType !== 'iPhoneApp') {
                    const { type } = detail || {}
                    getUserDetails(type)
                }
            })

            if (isUserSignedIn() && !loginPush) {
                invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'login' })
            }
        }
    }, [dispatch])

    return null
}
